// src/services/subDealer.service.js
import api from './api';

const subDealerService = {
  getAllSubDealers: async (companyId, page = 1, limit = 10, search = '') => {
    try {
      const params = { page, limit };
      if (companyId) params.companyId = companyId;
      if (search && search.trim()) params.search = search.trim();
      const response = await api.get('/sub-dealers', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-dealers:', error);
      throw error;
    }
  },

  getSubDealerById: async (id) => {
    try {
      const response = await api.get(`/sub-dealers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sub-dealer:', error);
      throw error;
    }
  },

  createSubDealer: async (data) => {
    try {
      const response = await api.post('/sub-dealers', data);
      return response.data;
    } catch (error) {
      console.error('Error creating sub-dealer:', error);
      throw error;
    }
  },

  updateSubDealer: async (id, data) => {
    try {
      const response = await api.post(`/sub-dealers/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating sub-dealer:', error);
      throw error;
    }
  },

  deleteSubDealer: async (id) => {
    try {
      const response = await api.delete(`/sub-dealers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting sub-dealer:', error);
      throw error;
    }
  },
};

export default subDealerService;